import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-fac-paper border-t border-border">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src="/logo192.png" alt="FAC Solutions" className="w-12 h-12 object-contain" />
              <span className="font-heading font-bold text-xl text-white">
                FAC<span className="text-fac-green">VALVE</span>
              </span>
            </Link>
            <p className="text-muted-foreground font-chinese max-w-md">
              FAC Solutions - 智慧灌溉閥門控制系統
              <br />
              Smart Irrigation Valve Control System
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-bold text-white uppercase tracking-wider mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/product" className="text-muted-foreground hover:text-fac-green transition-colors">
                  {t('nav_product')}
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-muted-foreground hover:text-fac-green transition-colors">
                  {t('nav_how_it_works')}
                </Link>
              </li>
              <li>
                <Link to="/company" className="text-muted-foreground hover:text-fac-green transition-colors">
                  {t('nav_company')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-muted-foreground hover:text-fac-green transition-colors">
                  {t('nav_contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-bold text-white uppercase tracking-wider mb-4">
              Contact
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-muted-foreground">
                <MapPin className="w-4 h-4 text-fac-green" />
                <span className="font-chinese">Global / 全球</span>
              </li>
              <li className="flex items-center gap-2 text-muted-foreground">
                <Mail className="w-4 h-4 text-fac-green" />
                <span>info@facsolutions.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © 2024 FAC Solutions. All rights reserved.
          </p>
          <p className="text-sm text-muted-foreground font-chinese">
            © 2024 FAC 智慧方案。保留所有權利。
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
